import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const NotFound = () => (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden px-4" data-testid="not-found">
        <div className="vm-grid-bg pointer-events-none absolute inset-0 opacity-40" aria-hidden="true" />
        <div className="relative text-center">
            <div className="vm-micro mb-6">AGENTVM://404</div>
            <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="text-6xl font-bold tracking-tight text-[#F5F9FF] sm:text-8xl"
            >
                4<span className="text-[#00D9FF] vm-glow">0</span>4
            </motion.h1>
            <p className="mt-6 font-mono text-xs tracking-[0.3em] text-[#B8C7D9]">RESOURCE NOT FOUND.</p>
            <p className="mt-2 font-mono text-[10px] tracking-[0.2em] text-[#B8C7D9]/50">
                THE REQUESTED PATH DOES NOT EXIST IN THIS SYSTEM.
            </p>
            <Link
                to="/"
                data-testid="not-found-return"
                className="mt-10 inline-block border border-[#1688FF]/70 bg-[#006CFF]/25 px-6 py-3 font-mono text-[11px] tracking-[0.26em] text-[#F5F9FF] transition-colors hover:bg-[#006CFF]/45"
            >
                [ RETURN TO SYSTEM ]
            </Link>
        </div>
    </div>
);

export default NotFound;
